import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLabel20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconLabel20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m17.275 12.764-4.51 4.51a1 1 0 0 1-1.415 0L3.793 9.718A1 1 0 0 1 3.5 9.01V3.5h5.51a1 1 0 0 1 .707.293l7.558 7.557a1 1 0 0 1 0 1.414M2.732 10.778A2.5 2.5 0 0 1 2 9.01V3.5A1.5 1.5 0 0 1 3.5 2h5.51a2.5 2.5 0 0 1 1.768.732l7.557 7.557a2.5 2.5 0 0 1 0 3.536l-4.51 4.51a2.5 2.5 0 0 1-3.536 0zM7.54 6.907a.633.633 0 1 1-1.267 0 .633.633 0 0 1 1.267 0m1.5 0a2.133 2.133 0 1 1-4.267 0 2.133 2.133 0 0 1 4.267 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLabel20);
